import React from 'react';

interface TabPanelProps {
  children?: React.ReactNode;
  id: string;
  openedPanelId: string | null;
}

const TabPanel = (props: TabPanelProps) => {
  const { children, id, openedPanelId, ...other } = props;

  return (
    <div
      id={`project-sidenav-tabpanel-${id}`}
      aria-labelledby={`project-sidenav-tab-${id}`}
      role="tabpanel"
      className="max-w-[calc(100vw_-_var(--page-spacing)_-_3.5rem)] h-96 pl-[calc(var(--page-spacing)_+_0.5rem)] pr-2 sm:p-2"
      hidden={openedPanelId !== id}
      {...other}
    >
      {openedPanelId === id && (
        <div className="w-80 max-w-full h-full p-4 bg-white shadow-grey-2 rounded-md">
          {children}
        </div>
      )}
    </div>
  );
};

export default TabPanel;
